import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useTranslation } from '../../translations';
import {
  ArrowUpIcon,
  ArrowRightIcon,
  ArrowDownIcon,
  ClockIcon
} from '@heroicons/react/24/outline';

const TaskList = ({ title, tasks = [] }) => {
  const { language } = useLanguage();
  const { t } = useTranslation(language);
  const getPriorityIcon = (priority) => {
    // Priority object ise priority_name'ini al
    let priorityText = priority;
    if (priority && typeof priority === 'object' && priority.priority_name) {
      priorityText = priority.priority_name;
    }

    // Priority undefined, null veya string değilse default icon döndür
    if (!priorityText || typeof priorityText !== 'string') {
      return <ClockIcon className="h-4 w-4 text-text-secondary dark:text-dark-text-secondary" />;
    }

    switch (priorityText.toLowerCase()) {
      case 'high':
      case 'urgent':
        return <ArrowUpIcon className="h-4 w-4 text-error-500" />;
      case 'medium':
        return <ArrowRightIcon className="h-4 w-4 text-warning-500" />;
      case 'low':
        return <ArrowDownIcon className="h-4 w-4 text-success-500" />;
      default:
        return <ClockIcon className="h-4 w-4 text-text-secondary dark:text-dark-text-secondary" />;
    }
  };

  const getPriorityColor = (priority) => {
    // Priority object ise priority_name'ini al
    let priorityText = priority;
    if (priority && typeof priority === 'object' && priority.priority_name) {
      priorityText = priority.priority_name;
    }

    // Priority undefined, null veya string değilse default color döndür
    if (!priorityText || typeof priorityText !== 'string') {
      return 'text-text-secondary dark:text-dark-text-secondary';
    }

    switch (priorityText.toLowerCase()) {
      case 'high':
      case 'urgent':
        return 'text-error-500';
      case 'medium':
        return 'text-warning-500';
      case 'low':
        return 'text-success-500';
      default:
        return 'text-text-secondary dark:text-dark-text-secondary';
    }
  };

  return (
    <div className="bg-white dark:bg-dark-background-main rounded-xl border border-background-secondary dark:border-dark-border shadow-sm">
      <div className="p-4 border-b border-background-secondary dark:border-dark-border">
        <h3 className="text-base font-semibold text-text-primary dark:text-dark-text-primary">{title}</h3>
      </div>
      <div className="p-4 max-h-96 overflow-y-auto">
        {tasks.length === 0 ? (
          <div className="text-center py-6 text-text-secondary dark:text-dark-text-secondary">
            <ClockIcon className="h-8 w-8 mx-auto mb-2 opacity-50" />
            <p className="text-sm">{t('noTasksFound')}</p>
          </div>
        ) : (
          <div className="space-y-2">
            {tasks.map((task) => (
              <div
                key={task.id}
                className="flex items-center justify-between p-2 bg-background-main dark:bg-dark-background-secondary/50 rounded-lg hover:bg-background-secondary dark:hover:bg-dark-background-secondary transition-colors duration-200"
              >
                <div className="flex items-center space-x-2 flex-1">
                  <div className="flex items-center space-x-1">
                    {getPriorityIcon(task.priority)}
                    <span className="text-xs font-medium text-text-secondary dark:text-dark-text-secondary">
                      #{task.id}
                    </span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-xs font-medium text-text-primary dark:text-dark-text-primary truncate">
                      {task.title}
                    </p>
                    {task.project_name && (
                      <p className="text-xs text-text-secondary dark:text-dark-text-secondary truncate">
                        {task.project_code && `${task.project_code} - `}{task.project_name}
                      </p>
                    )}
                  </div>
                </div>
                <div className="flex items-center space-x-1">
                  <span className={`text-xs font-medium ${getPriorityColor(task.priority)}`}>
                    {task.priority?.priority_name || task.priority}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TaskList;